module.exports = __webpack_public_path__ + "img/loading.99177000.gif";